import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo_tools_inventor from '../assets/img/logo_tools_inventor.png';
import {
  BrowserRouter as Router
} from "react-router-dom";

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            <img src={logo_tools_inventor} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Inicio</Nav.Link>
              <Nav.Link href="#clients" className={activeLink === 'clients' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('clients')}>Clientes</Nav.Link>
              <Nav.Link href="#services" className={activeLink === 'services' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Servicios</Nav.Link>
              <Nav.Link href="#lenguajes" className={activeLink === 'lenguajes' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('lenguajes')}>Tecnologías</Nav.Link>
              <Nav.Link href="#portafolio" className={activeLink === 'portafolio' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('portafolio')}>Portafolio</Nav.Link>
            </Nav>
            <span className="navbar-text">
              <a href="#contact" className="subtitle-none"><button className="button">Contácto</button></a>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  )
}
